<app-lms-modal-frame [title]="'Branch Performance Report'" [pageHeadWidth]="700">
  <div modal-body class="p-0">
    <div class="container-fluid center-screen">

    <section class="performance-section">

      <!-- ── Branch summary stats ── -->
      <div class="branch-stats-panel">
        <div class="stat-card">
          <span class="stat-label">Total loans disbursed</span>
          <span class="stat-value">{{totalBranchCount}}</span>
        </div>
        <div class="stat-card">
          <span class="stat-label">Total amount disbursed</span>
          <span class="stat-value">{{totalBranchCapital | zaRcurrency}}</span>
        </div>
        <div class="stat-card stat-card--wide">
          <span class="stat-label">Period</span>
          <span class="stat-value stat-value--sm">{{startDate | date}} &rarr; {{endDate | date}}</span>
        </div>
      </div>

      <!-- ── User performance table ── -->
      <div class="table-panel">
        <div class="table-scroll-wrapper">
          <table class="performance-table" #table>
            <caption class="table-caption">User performance</caption>
            <thead class="sticky-thead">
              <!-- Group header row -->
              <tr class="group-header-row">
                <th rowspan="2" class="col-username" scope="col">User name</th>
                <th colspan="2" class="group-new" scope="colgroup">NEW</th>
                <th colspan="7" class="group-repeat" scope="colgroup">REPEAT</th>
                <th colspan="3" class="group-total" scope="colgroup">TOTALS</th>
              </tr>
              <!-- Column header row -->
              <tr class="col-header-row">
                <th scope="col">Loans</th>
                <th scope="col">Capital</th>

                <th scope="col">New</th>
                <th scope="col">Active</th>
                <th scope="col">Pending</th>
                <th scope="col">Submitted</th>
                <th scope="col">Rejected</th>
                <th scope="col">Cancelled</th>
                <th scope="col">Disbursed</th>
                <th scope="col">Capital</th>  <!-- repeat capital -->

                <th scope="col">Loans</th>
                <th scope="col">Capital</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let results of performanceList" class="perf-row">
                <td data-label="User name" class="col-username-cell">{{results.userName}}</td>

                <td data-label="New loans"         class="num highlight">{{results.newLoanCount}}</td>
                <td data-label="New loans capital"  class="amount highlight">{{results.newLoanCapital | zaRcurrency}}</td>

                <td data-label="New"        class="num">{{results.newCount}}</td>
                <td data-label="Active"     class="num">{{results.activeCount}}</td>
                <td data-label="Pending"    class="num">{{results.pendingCount}}</td>
                <td data-label="Submitted"  class="num">{{results.submittedCount}}</td>
                <td data-label="Rejected"   class="num muted">{{results.rejectedCount}}</td>
                <td data-label="Cancelled"  class="num muted">{{results.cancelledCount}}</td>
                <td data-label="Disbursed"  class="num highlight">{{results.disbursedCount}}</td>
                <td data-label="Repeat capital" class="amount highlight">{{results.repeatLoanCapital | zaRcurrency}}</td>

                <td data-label="Total loans"   class="num total">{{results.totalCount}}</td>
                <td data-label="Total capital" class="amount total">{{results.totalCapital | zaRcurrency}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </section>
  </div>
  </div>
  <div modal-actions class="action-bar">
    <button class="btn-action btn-export" (click)="exportLoansToExcel()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
        <polyline points="7 10 12 15 17 10"/>
        <line x1="12" y1="15" x2="12" y2="3"/>
      </svg>
      Export full report to Excel
    </button>
    <button class="btn-action btn-close-modal" type="button" (click)="close()">Close</button>
  </div>
</app-lms-modal-frame>
<style scoped>
  .table-divider-color tbody tr:nth-of-type(odd) {
    --bs-table-accent-bg: #f9f9f9;
    background-color: var(--bs-table-accent-bg);
  }
</style>
